import Resource from '@/services/resources/common';

export default class ServerResource extends Resource {
  constructor(entrypoint = '/servers', alias = 'Server') {
    super(entrypoint, alias);
  }
}
